
import { PrimeIcons } from 'primeng/api';

export interface TicketDocumentDto {

  dataBase64: string;
  mimeType: string;
  name: string;

}

export interface TicketPostComment {

  comment: string;

}

export interface TicketCommentDto {

  id: number;
  enteredOn: Date;
  enteredOnString: string;
  comment: string;
  enteredByEu: boolean;

}

export interface TicketDocumentListEntryDto {

  id: number;
  documentName: string;
  uploadedOn: Date;
  uploadedOnString: string;
  uploadedByEu: boolean;

}

export interface TicketDto {

  id: number;
  alias: string;
  name: string;

  euDescription: string;
  createdDate: string;

  createdDateString: string;
  ticketStatus: TicketStatus;
  anticipatedEnDate: string;
  ticketClosed: boolean;

  documents: TicketDocumentListEntryDto[];
  comments: TicketCommentDto[];

}

export type TicketStatus =
  | 'draft'
  | 'assigned'
  | 'working'
  | 'awaiting_customer'
  | 'awaiting_partner'
  | 'resolved'
  | 'on_hold'
  | 'cancelled'
  | 'awaiting_appointment';

export interface TicketStatusMeta {
  label: string;
  icon: string;
  color: string;
  backgroundColor: string;
  active: boolean;
}


export const TICKET_STATUS_MAP: Record<TicketStatus, TicketStatusMeta> = {
  draft: {
    label: 'Entwurf',
    icon: PrimeIcons.PENCIL, // pi pi-pencil
    color: 'gray-800',
    backgroundColor: 'gray-200',
    active: true,
  },
  assigned: {
    label: 'Zugeordnet',
    icon: PrimeIcons.EXCLAMATION_TRIANGLE, // pi pi-exclamation-triangle (as "brake-warning")
    color: 'cyan-800',
    backgroundColor: 'cyan-200',
    active: true,
  },
  working: {
    label: 'In Arbeit',
    icon: PrimeIcons.SPINNER, // pi pi-spinner
    color: 'blue-700',
    backgroundColor: 'blue-200',
    active: true,
  },
  awaiting_customer: {
    label: 'Warte auf Kunden',
    icon: PrimeIcons.PAUSE, // pi pi-pause
    color: 'yellow-700',
    backgroundColor: 'yellow-200',
    active: true,
  },
  awaiting_partner: {
    label: 'Warte auf Partner',
    icon: PrimeIcons.PAUSE, // same as above
    color: 'teal-700',
    backgroundColor: 'teal-200',
    active: true,
  },
  resolved: {
    label: 'Abgeschlossen',
    icon: PrimeIcons.FLAG, // pi pi-flag
    color: 'green-700',
    backgroundColor: 'green-200',
    active: false,
  },
  on_hold: {
    label: 'WVL',
    icon: PrimeIcons.STOP, // pi pi-hand-stop
    color: 'orange-700',
    backgroundColor: 'orange-200',
    active: true,
  },
  cancelled: {
    label: 'Abgebrochen',
    icon: PrimeIcons.BAN, // pi pi-ban
    color: 'red-800',
    backgroundColor: 'red-200',
    active: false,
  },
  awaiting_appointment: {
    label: 'Warte auf Termin',
    icon: PrimeIcons.CALENDAR_TIMES, // pi pi-calendar-times
    color: 'indigo-700',
    backgroundColor: 'indigo-200',
    active: true,
  }
};
